import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CognitoUserPool } from 'amazon-cognito-identity-js';

@Injectable()
export class CognitoAuthService {
  private static _USER_POOL_ID = environment.cognito.userPoolId;
  private static _CLIENT_ID = environment.cognito.clientId;

  private static _POOL_DATA: any = {
    UserPoolId: CognitoAuthService._USER_POOL_ID,
    ClientId: CognitoAuthService._CLIENT_ID
  };

  private static _AUTH_DATA: any = {
    UserPoolId: CognitoAuthService._USER_POOL_ID,
    ClientId: CognitoAuthService._CLIENT_ID,
    AppWebDomain: environment.cognito.webDomain,
    TokenScopesArray: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
    ResponseType: 'TOKEN'
  };

  private _cognitoUserPool: CognitoUserPool;

  constructor() {
    this._cognitoUserPool = new CognitoUserPool(CognitoAuthService._POOL_DATA);
  }

  getUserPool() {
    return this._cognitoUserPool;
  }

  createLogoutUrl(returnUrl: string) {
    return (
      `${CognitoAuthService._AUTH_DATA.AppWebDomain}/logout?` +
      `client_id=${CognitoAuthService._AUTH_DATA.ClientId}` +
      `&logout_uri=${returnUrl}/logout`
    );
  }

  createSocialSignInUrl(state: string, returnUrl: string, identityProvider?: string, identityIdentifier?: string) {
    let url = `${CognitoAuthService._AUTH_DATA.AppWebDomain}/authorize?`;
    if (identityIdentifier) {
      url += `idp_identifier=${identityIdentifier}`;
    } else {
      url += `identity_provider=${identityProvider}`;
    }

    return (
      `${url}` +
      `&redirect_uri=${returnUrl}` +
      `&response_type=${CognitoAuthService._AUTH_DATA.ResponseType}` +
      `&client_id=${CognitoAuthService._AUTH_DATA.ClientId}` +
      `&state=${this.composeState(state, identityIdentifier || identityProvider)}` +
      `&scope=${CognitoAuthService._AUTH_DATA.TokenScopesArray.join(' ')}`
    );
  }

  composeState(state: string, tenant: string) {
    return `st=${state}+tn=${tenant}`;
  }

  parseAuthResponseFromCognito(fragment: string): boolean {
    if (fragment != null && fragment.indexOf('id_token') !== -1 && fragment.indexOf('access_token') !== -1) {
      const params: any = this.parseParams(fragment, '&');

      if (params.id_token && params.access_token && params.state) {
        const stateInfo: any = this.parseParams(decodeURIComponent(params.state), '+');
        // console.log(stateInfo);
        if (stateInfo.st && stateInfo.tn) {
          window.location.href = `${this.buildTenantUrl(stateInfo.tn)}?state=${stateInfo.st}&id_token=${params.id_token}&access_token=${
            params.access_token
          }`;
          return true;
        }
      }
    }
    return false;
  }

  parseParams(params: string, separator: string): any {
    return params.split(separator).reduce(function(result, item) {
      const parts = item.split('=');
      result[parts[0]] = parts[1];
      return result;
    }, {});
  }

  buildTenantUrl(tenant: string) {
    return `https://${tenant}.de`;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/cognitoAuth.service.ts